import State from "@/helpers/pattern/state";
import { PlantillaCorreo } from "@/models/generales/plantilla-correo";
import { modelIsModified } from "@/helpers/vue-mc";
import PlantillaCorreoAPI from "@/services/generales/plantillaCorreo";
import CombosAPI from "@/services/catalogos";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";
import * as wysiwygMethods from "@/helpers/wysiwyg-methods";

/**
 * State Pattern for plantillacorreo form
 */
export default class PlantillaCorreoStates extends State {
  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.plantillaCorreo = new PlantillaCorreo();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.plantillaCorreo) || $data.view.action.submit.busy || !modelIsModified($data.plantillaCorreo);
      }
      , async loadSelectsData({ $data }) {
        const { data: { results: { combo: responseGruposList } } } = await CombosAPI.get({ option: "grupos" });
        $data.view.elem.select.groups.options = responseGruposList || [];
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.loadSelectsData();
          this.resetValidators();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;

          // View configuration form
          $data.view.elem.input.clave.disabled = false;
        }
        , async submit({ $data }, {
          clave, descripcion, remitente, multiListPerfilesDestinatarios, destinatariosOpcionales, cc, cco, asunto, cuerpo, status, version 
        }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await PlantillaCorreoAPI.save({
              clave
              , descripcion
              , remitente
              , multiListPerfilesDestinatarios: multiListPerfilesDestinatarios ? multiListPerfilesDestinatarios.join() : ""
              , destinatariosOpcionales
              , cc
              , cco
              , asunto
              , cuerpo
              , status
              , version
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.plantillaCorreoTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, {
          clave, descripcion, remitente, multiListPerfilesDestinatarios, destinatariosOpcionales, cc, cco, asunto, cuerpo, status, version 
        }) {
          // Reset Models and validators
          this.loadSelectsData();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;

          // View configuration form
          $data.view.elem.input.clave.disabled = true;

          let arrayValues = [];
          if (multiListPerfilesDestinatarios != null) {
            let perfiles = multiListPerfilesDestinatarios.split(",");
            $data.view.elem.select.groups.options.forEach(function (option) {
              if (perfiles.includes(option.code + "")) arrayValues.push({ name: option.name, code: option.code });
            });
          }
          multiListPerfilesDestinatarios = arrayValues;

          $data.plantillaCorreo = new PlantillaCorreo({
            clave
            , descripcion
            , remitente
            , multiListPerfilesDestinatarios
            , destinatariosOpcionales
            , cc
            , cco
            , asunto
            , cuerpo
            , status
            , version
          });

          this.resetValidators();
          scrollToForm($data);
        }
        , async submit({ $data, $setState }, {
          clave, descripcion, remitente, multiListPerfilesDestinatarios, destinatariosOpcionales, cc, cco, asunto, cuerpo, status, version 
        }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const contentImageReplaced = await wysiwygMethods.replaceImageSourceById(cuerpo);

            const response = await PlantillaCorreoAPI.update({
              clave
              , descripcion
              , remitente
              , multiListPerfilesDestinatarios: multiListPerfilesDestinatarios ? multiListPerfilesDestinatarios.join() : ""
              , destinatariosOpcionales
              , cc
              , cco
              , asunto
              , cuerpo: contentImageReplaced.content
              , imagenes: contentImageReplaced.images
              , status
              , version
            });

            $data.$refs.plantillaCorreoTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/generales/plantillaCorreo/plantilla-correo-state.js